import styled from 'styled-components';
import { MenuItem as MuiMenuItem } from '@material-ui/core';

export const Menu = styled.div`
  display: block;
  position: absolute;
  color: var(--black);
  border-radius: 4px;
  background-color: var(--white);
  min-width: 230px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  padding: 12px 16px;
  z-index: 1;
  top: 1px;
  right: 0px;
  max-width: 280px;
  position: absolute;
`;

export const MenuItem = styled(MuiMenuItem)`
  &.MuiMenuItem-root {
    font-size: 1.4rem;
  }
`;


export const Header = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderTitle = styled.h2`
  color: var(--black);
  font-size: 2rem;
  font-weight: 600;
`;

export const HeaderTitleLine = styled.div`
  margin-top: 8px;
  border-radius: 4px;
  width: 87px;
  height: 3px;
  background: var(--orange);
`;

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderRight = styled.div`
  cursor: pointer;
  position: relative;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: all 0.5s;

  &:hover {
    background: #d6dde2;
  }
`;

export const HeaderRightUser = styled.div`
  margin-left: 8px;
  margin-right: 80px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const HeaderRightUserName = styled.span`
  text-transform: uppercase;
  font-size: 1.2rem;
  font-weight: 500;
  `;

export const HeaderRightUserLevel = styled.span`
  font-size: 0.8rem;
  font-weight: 500;
`;